import React, { Component, isValidElement } from 'react';

import { getGlobalObject } from '../../utils/getGlobalObject';
import Fallback from '../Fallback';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, prevScope: props.scope };
    }

    static defaultProps = {
        scope: 'error-boundary',
    };

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error, hasError: true };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.prevScope !== props.scope) {
            return {
                error: undefined,
                hasError: false,
                prevScope: props.scope,
            };
        }

        return state;
    }

    componentDidCatch(error) {
        const RumGlobal = getGlobalObject().DD_RUM;

        if (RumGlobal) {
            RumGlobal.addError(
                error,
                {
                    scope: this.props.scope,
                },
                'source',
            );
        }
    }

    render() {
        const { hasError, error } = this.state;

        const {
            backButtonText,
            backButtonUrl,
            children,
            fallback,
        } = this.props;

        if (!hasError || !error) {
            return children;
        }

        if (isValidElement(fallback) || typeof fallback === 'string') {
            return fallback;
        }

        if (typeof fallback === 'function') {
            return fallback(error);
        }

        return <Fallback backButtonText={backButtonText} backButtonUrl={backButtonUrl} />;
    }
}

export default ErrorBoundary;
